import { action } from 'satcheljs';
import type { QuickComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import type { QuickComposeViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import EventScope from 'owa-service/lib/contract/EventScope';
import type { CalendarEvent } from 'owa-calendar-types';
import { addDatapointConfig } from 'owa-analytics-actions';

// Shows the callout for quick compose

let showQuickCompose = action('showQuickCompose', (
    anchor: HTMLDivElement | string, //sets the target point that the callout it anchored to
    entrySource: QuickComposeEntrySourceType,
    viewType: QuickComposeViewType,
    initialCalendarEvent?: Partial<CalendarEvent>,
    eventScope: EventScope = EventScope.Default
) =>
    addDatapointConfig(
        {
            name: 'showQuickCompose',
        },
        {
            anchor: anchor,
            entrySource: entrySource,
            viewType: viewType,
            initialCalendarEvent: initialCalendarEvent,
            eventScope: eventScope,
        }
    )
);

export default showQuickCompose;
